import GalleryTabs from "../Components/GalleryTabs";

function Gallery() {
  return (
    <div className="gallery-page">
      <GalleryTabs />
    </div>
  );
}

export default Gallery;
